import { DataItem } from 'scrivito'

import { Invoice } from '@/Data/Invoice/InvoiceDataClass'
import { DataScopeOrder } from '@/Data/types'
import { useDataClassIndex } from '@/hooks/useDataClassIndex'

interface Args {
  subjectId: string
  subjectRelation: string
  search: string
  order: DataScopeOrder
  listSize: number
}

interface InvoiceRow {
  id: string
  invoice: DataItem
}

export const useInvoiceTabData = ({
  subjectId,
  subjectRelation,
  search,
  order,
  listSize,
}: Args) => {
  const { dataItems, hasMore, loadMore, count } = useDataClassIndex(
    Invoice,
    {
      filters: { [subjectRelation]: subjectId },
      order: [order],
      search: search || undefined,
    },
    listSize,
  )

  const items: InvoiceRow[] = dataItems.map((invoice) => ({
    id: invoice.id(),
    invoice,
  }))

  return { items, hasMore, loadMore, count }
}
